var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite2Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Differentiators/Website-2/Active/24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Differentiators/Website-2/Active/24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Website-2",
    transform: "translate(2.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#DB3725",
    points: "6 2.66040462 5.00474342 3.25 4 2.66040462 4 0.25 6 0.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1363636,13.25 L0.552181543,13.25 C0.2470064,13.25 0,13.1035 0,12.923 L0,12.25 L11.1363636,12.25 L20,12.25 L20,12.9226637 C20,13.1030735 19.728675,13.25 19.3934543,13.25 L11.1363636,13.25 Z",
    id: "Combined-Shape",
    fill: "#001823"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#001823",
    strokeLinejoin: "round",
    x: 2,
    y: 0,
    width: 16,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DB3725",
    x: 4,
    y: 5.25,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#DB3725",
    x: 11,
    y: 5.25,
    width: 4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#001823",
    x: 4,
    y: 6.75,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#001823",
    x: 11,
    y: 6.75,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#001823",
    x: 4,
    y: 8.25,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#001823",
    x: 11,
    y: 8.25,
    width: 5,
    height: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite2Icon);
export default __webpack_public_path__ + "static/media/Website2Icon.a4c405af1d2bd2276e1ae76c102c19df.svg";
export { ForwardRef as ReactComponent };